import EventEmitter from './eventEmitter';

export default class Slide extends EventEmitter {
  constructor(opts) {
    super();
    try {
      this.ele = document.querySelector(opts.ele);
      this.slideCon = this.ele.querySelector('[data-slide="slide-con"]');
      this.slides = this.slideCon.querySelectorAll(':scope>li:not([disabled])');
      this.autoPlay = opts.autoPlay;
      this.size={
        width:this.slideCon.offsetWidth,
        height:this.slideCon.offsetHeight
      }
      this.state = {
        currentIndex : 0,
        maxIndex:this.slides.length,
        isSliding:false
      }
      this.arrows = opts.isArrow ? this._setBtns() : null;
      this.paginations = opts.isPagination ? this._setPaginations() : null;
      this.type = opts.type ? opts.type : '';
      this._init();

    }
    catch (e){
      console.log(e)

    }
  }
  _setBtns(){
    let btns=[];
    for(let v of ['prev', 'next']){
      let btn = document.createElement('BUTTON');
      btn.classList.add('slide-btn');
      btn.classList.add(v);
      btn.setAttribute('data-slide', 'slide-btn');
      btns.push(btn);
      this.ele.appendChild(btn);
    }
    return btns;
  }

  _setPaginations(){
    let pages=[];
    let con =  document.createElement('DIV');
    con.classList.add('slide-pagination')
    for(let i = 0; i < this.state.maxIndex; i++){

      let btn = document.createElement('BUTTON');
      btn.classList.add('slide-page');
      btn.setAttribute('data-slide', 'slide-page');
      btn.setAttribute('index', i);
      pages.push(btn);
      con.appendChild(btn);
    }

    this.ele.appendChild(con);
    return pages;
  }
  _init(){

    this.paginations.forEach((page)=>{
      page.addEventListener('click', (e)=>{
        if(e.currentTarget.classList.contains('active'))return;
        let index = e.currentTarget.getAttribute('index');
        let direction = (index > this.state.currentIndex ) ? 1 : -1;
        this._slide(index, direction)
      });
    });
    this.arrows.forEach((arrow)=>{
      arrow.addEventListener('click', (e)=>{
        let index = this.state.currentIndex, direction = 1;
        if(e.currentTarget.classList.contains('prev')){
          index--;
          if(index < 0)index = this.state.maxIndex - 1;
          direction = -1;
        }else{
          index++;
          if(index >= this.state.maxIndex) index=0;
        }
        this._slide(index, direction)
      });
    });
    this.slides.forEach((slide)=>{
      TweenMax.set(slide, {x:this.size.width});
    });
    this.slides[this.state.currentIndex].classList.add('active')
    TweenMax.set(this.slides[this.state.currentIndex], {x:0});
    this.paginations[this.state.currentIndex].classList.add('active')
  }

  _slide(index, dir){

    if(this.size.width == 0) this._setSize();
    if(this.state.isSliding)return;
    if(index == this.state.currentIndex)return;
    let direction = dir ? dir : 1;
    let currentIndex = this.state.currentIndex;
    let outEase= Cubic.easeIn;
    if(this.type == 'nomal')outEase = Cubic.easeOut;
    this.state.isSliding = true;

    this.slides[index].classList.add('active');
    this.slides[currentIndex].classList.add('hide');
    TweenMax.set(this.slides[index], {x:this.size.width * direction});
    TweenMax.to(this.slides[index], 0.5, {x:0, ease:Cubic.easeOut});
    TweenMax.to(this.slides[currentIndex], 0.5, {x:this.size.width * -direction, ease:outEase, onComplete: this._slideComplete, onCompleteParams: [this, index, currentIndex]});

    this.paginations[currentIndex].classList.remove('active')
    this.paginations[index].classList.add('active')


    this.emit('startSlide', index, currentIndex);
  }
  _slideComplete(thisv, index, currentIndex){
    thisv.slides[index].classList.remove('active')
    thisv.slides[currentIndex].classList.remove('hide')
    thisv.state.currentIndex = index;
    thisv.state.isSliding = false;

  }
  _setSize(){
    this.size={
      width:this.slideCon.offsetWidth,
      height:this.slideCon.offsetHeight
    }
  }
  set select(index){

    this._slide(index, 1)
  }
}




// WEBPACK FOOTER //
// ./src/js/components/slide.js